export const BASE_EMOTIONS = [
  { emotion: 'Infuriated', x: 12.38, y: 82.58 },
  { emotion: 'Excited', x: 74.26, y: 82.18 },
  { emotion: 'Happy', x: 87.62, y: 73.07 },
  { emotion: 'Angry', x: 9.42, y: 66.34 },
  { emotion: 'Delighted', x: 77.73, y: 65.55 },
  { emotion: 'Alarmed', x: 34.66, y: 59.61 },
  { emotion: 'Frustrated', x: 13.38, y: 51.69 },
  { emotion: 'Glad', x: 81.68, y: 49.71 },
  { emotion: 'Annoyed', x: 36.14, y: 43.77 },
  { emotion: 'Curious', x: 63.87, y: 41.79 },
  { emotion: 'Content', x: 85.64, y: 29.91 },
  { emotion: 'Satisfied', x: 62.88, y: 17.24 },
  { emotion: 'Relaxed', x: 86.14, y: 4.17 },
]

export const EMOTION_MAP = {
  Infuriated: { valence: 12.38, arousal: 82.58 },
  Excited: { valence: 74.26, arousal: 82.18 },
  Happy: { valence: 87.62, arousal: 73.07 },
  Angry: { valence: 9.42, arousal: 66.34 },
  Delighted: { valence: 77.73, arousal: 65.55 },
  Alarmed: { valence: 34.66, arousal: 59.61 },
  Frustrated: { valence: 13.38, arousal: 51.69 },
  Glad: { valence: 81.68, arousal: 49.71 },
  Annoyed: { valence: 36.14, arousal: 43.77 },
  Curious: { valence: 63.87, arousal: 41.79 },
  Content: { valence: 85.64, arousal: 29.91 },
  Satisfied: { valence: 62.88, arousal: 17.24 },
  Relaxed: { valence: 86.14, arousal: 4.17 },
}
